import { render, staticRenderFns } from "./LeftSidebar.vue?vue&type=template&id=3c9a5f5f&scoped=true"
import script from "./LeftSidebar.vue?vue&type=script&lang=js"
export * from "./LeftSidebar.vue?vue&type=script&lang=js"
import style0 from "./LeftSidebar.vue?vue&type=style&index=0&id=3c9a5f5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9a5f5f",
  null
  
)

export default component.exports